import { inject, Injectable } from '@angular/core';
import { Crisp } from 'crisp-sdk-web';
import {
  AuthService,
  ProfileService,
  SelectedTeamService,
} from '@tokenbox/services';
import { WebAppDesignTokensStateService } from '../design-tokens/web-app-design-tokens-state.service.ts';
import { take } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class InAppSupportService {
  private authService = inject(AuthService);
  private profileService = inject(ProfileService);
  private selectedTeamService = inject(SelectedTeamService);
  private designTokensStateService = inject(WebAppDesignTokensStateService);

  initializeChat(crispWebsiteId: string) {
    Crisp.configure(crispWebsiteId, {
      autoload: false,
    });
    Crisp.load();
    Crisp.chat.hide();

    Crisp.session.onLoaded(() => {
      if (Crisp.chat.unreadCount() > 0) {
        this.showChat();
      }

      this.authService.isLoggedIn$.subscribe((isLoggedIn) => {
        try {
          if (!isLoggedIn) {
            Crisp.setTokenId();
            Crisp.session.reset();
          }
        } catch (error) {
          console.error('Failed to unset Crisp session', error);
        }
      });
    });

    Crisp.message.onMessageReceived(() => {
      this.showChat();
    });

    Crisp.message.onMessageSent(() => {
      this.profileService.profile$
        .pipe(take(1))
        .subscribe(({ id, name, email, company }) => {
          Crisp.session.setData({ userId: id ?? '-' });
          Crisp.user.setNickname(name ?? '-');
          Crisp.user.setEmail(email ?? '-');
          Crisp.user.setCompany(company ?? '-');
        });

      this.selectedTeamService.selectedTeam$.pipe(take(1)).subscribe((team) => {
        Crisp.session.setData({ teamId: team?.id ?? '-' });
      });

      this.designTokensStateService.designTokensState$
        .pipe(take(1))
        .subscribe((designTokensState) => {
          Crisp.session.setData({
            branchId: designTokensState?.branch?.id ?? '-',
          });
          Crisp.session.setData({
            workspaceId: designTokensState?.workspace?.id ?? '-',
          });
          Crisp.session.setData({
            baseSnapshotId: designTokensState?.baseSnapshot?.id ?? '-',
          });
          Crisp.session.setData({
            numberOfEvents: designTokensState?.events?.length ?? '-',
          });
          Crisp.session.setData({
            latestEventId: designTokensState?.events?.at(-1)?.id ?? '-',
          });
        });
    });
  }

  showChat() {
    Crisp.chat.show();
    Crisp.chat.open();
  }
}
